import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['cover'];

  toggleSpotifyEmbed() {
    this.coverTarget.classList.toggle('c-pages-premiere__main-column--embed-active');
  }
}
